/**
 * BatchVariantPicker - Variant count selection [1][2][3][4][5]
 */

import { cn } from '@/lib/utils';

interface BatchVariantPickerProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  disabled?: boolean;
}

export function BatchVariantPicker({
  value,
  onChange,
  max = 5,
  disabled = false,
}: BatchVariantPickerProps) {
  const variants = Array.from({ length: max }, (_, i) => i + 1);

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
        Varianten pro Bild
      </h4>

      <div className="flex gap-2">
        {variants.map((v) => (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            disabled={disabled}
            className={cn(
              'w-10 h-10 rounded-lg font-medium text-sm transition-all',
              value === v
                ? 'bg-orange-500 text-white shadow-sm'
                : 'bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-200 dark:hover:bg-neutral-700',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            {v}
          </button>
        ))}
      </div>

      <p className="text-xs text-neutral-500 dark:text-neutral-400">
        Jedes Bild wird {value}x mit unterschiedlichem Seed generiert
      </p>
    </div>
  );
}
